import { render } from "./App.vue?vue&type=template&id=81083964&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=81083964&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=81083964&lang=css"

import exportComponent from "/var/www/html2/esmanage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81083964"]])

export default __exports__